export default [
  {
    target: '#main-title',
    content:
      'Welcome to the Philly School Experience Survey — Question Explorer page. Here you can investigate responses to specific survey questions.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#main-content-side',
    content:
      'Data on this page summarizes the responses to a specific question, which is displayed above the data visualizations. A question is automatically selected by default.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#main-content-side',
    content:
      'In the area below you can view charts, tables, and maps related to the selected question. To summarize responses (for example, by school), "Percent Most Positive" scores are displayed. This is the percentage of respondents that selected the best (most positive) response to the question.',
    params: { enableScrolling: true },
    offset: -400,
  },
  {
    target: '#main-question-filter-panel',
    content:
      'To select a new question, click the + button next to the question in the "Select a question" panel. Here, you can scroll through a list of questions or type in key words to search. Additionally, click on "Question Categories" to view options that can help narrow down the list of questions.',
    params: { enableScrolling: true },
    offset: -200,
  },
  {
    target: '#main-tour-button',
    content: 'Press here to take this tour again.',
    params: { enableScrolling: true },
    offset: -400,
  },
]
